'use client';
import React from 'react';
import { OrderActions as Shared } from '@launchstore/shared-puck';
import { useOrderData } from '@/lib/hooks/useOrderData';

const SharedRender = (Shared as any).render;

/**
 * Storefront OrderActions — wires the action buttons to real navigation using
 * the order + fulfillment data. Falls back to the shared placeholder (no-op
 * handlers) when no order is present (editor preview).
 */
function OrderActionsImpl(props: any) {
  const { order, countryCode } = useOrderData();
  if (!order) {
    return <SharedRender {...props} />;
  }

  const base = countryCode ? `/${countryCode}` : '';
  const orderHref = `${base}/account/orders/${order.id}`;
  const supportHref = `${base}/customer-service`;
  const trackingUrl = (order as any).fulfillments?.[0]?.labels?.[0]?.tracking_url;

  const nav = (href: string) => () => {
    if (typeof window !== 'undefined') window.location.href = href;
  };

  return (
    <SharedRender
      {...props}
      onInvoice={nav(orderHref)}
      onTrack={
        trackingUrl
          ? () => { if (typeof window !== 'undefined') window.open(trackingUrl, '_blank'); }
          : nav(orderHref)
      }
      onSupport={nav(supportHref)}
      onReorder={nav(orderHref)}
      onReturn={nav(orderHref)}
    />
  );
}

export const OrderActions: any = {
  ...Shared,
  render: (props: any) => <OrderActionsImpl {...props} />,
};

export default OrderActions;
